import { createElement, useCallback, useState, useEffect } from 'react';
import { Input, Icon, Balloon, NumberPicker } from '@alifd/next';
import { formatMoney } from '@/utils';
const NumberRangeFilter = ({ onChange, name, fieldName, type, }) => {
    const [number, setDate] = useState([]);
    const [numberStr, setNumberStr] = useState();
    const isMoney = type === 'money';
    useEffect(() => {
        setDate([
            {
                operator: '>=',
                dataType: 'number',
                value: null,
                name,
                fieldName,
            },
            {
                operator: '<=',
                dataType: 'number',
                value: null,
                name,
                fieldName,
            },
        ]);
    }, [fieldName, name]);
    const renderDate = useCallback((number) => {
        const [start, end] = number;
        let numberStr;
        if (start?.value && end?.value) {
            numberStr = `${isMoney ? formatMoney(start?.value) : start?.value} ~ ${isMoney ? formatMoney(end?.value) : end?.value}`;
        }
        else if (start?.value) {
            numberStr = `>= ${isMoney ? formatMoney(start?.value) : start?.value}`;
        }
        else if (end?.value) {
            numberStr = `<= ${isMoney ? formatMoney(end?.value) : end?.value}`;
        }
        return numberStr;
    }, [isMoney]);
    const innerAfterChange = useCallback((value, operator) => {
        if (operator === '>=') {
            number[0].value = value;
        }
        else {
            number[1].value = value;
        }
        onChange(number);
        setDate(number);
        setNumberStr(renderDate(number));
    }, [number, onChange, renderDate]);
    return (createElement(Input, { value: numberStr, className: "filter-input", trim: true, hasClear: true, innerAfter: createElement(InnerAfter, { onChange: innerAfterChange, type: type }), readOnly: true }));
};
const InnerAfter = ({ onChange, type }) => {
    let moneyProps = {};
    if (type === 'money') {
        moneyProps = {
            min: 0,
            percision: 2,
            format: (val) => formatMoney(val),
        };
    }
    return (createElement(Balloon, { v2: true, align: "b", closable: false, arrowPointToCenter: true, triggerType: "click", trigger: createElement(Icon, { type: "filter", size: "xs", style: { margin: 4, cursor: 'pointer', color: '#999' } }), cache: true },
        createElement("div", { style: { display: 'flex', flexDirection: 'column', rowGap: 4 } },
            createElement(NumberPicker, { ...moneyProps, onChange: (value) => onChange(value, '>='), placeholder: ">=", style: { width: 200 } }),
            createElement(NumberPicker, { ...moneyProps, onChange: (value) => onChange(value, '<='), placeholder: "<=", style: { width: 200 } }))));
};
export default NumberRangeFilter;
